'use client'
import React from 'react'

import { Card } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { cn } from '@/utilities/ui'
import { i18n } from './i18n'
import { useLocale } from '@/providers/Locale'

interface Props {
    className?: string
    fullWidthCta?: boolean
}

export const NewsletterSignup: React.FC<Props> = ({ className, fullWidthCta }) => {
    const { locale } = useLocale()
    return (
        <div className={className}>
            <h2 className='font-bold text-xl mb-4'>📬 {i18n[locale].signupHeading}</h2>
            <Card className='p-4 flex flex-col gap-4'>
                <h3>{i18n[locale].signupDescription}</h3>
                <Input type='email' placeholder={i18n[locale].inputPlaceholder}></Input>
                <Button className={cn('bg-accent', { 'w-max': !fullWidthCta })}>{i18n[locale].ctaText}</Button>
            </Card>
        </div>
    )
}
